import { render, staticRenderFns } from "./MobileMenu.vue?vue&type=template&id=12db577d&"
import script from "./MobileMenu.vue?vue&type=script&lang=ts&"
export * from "./MobileMenu.vue?vue&type=script&lang=ts&"
import style0 from "./MobileMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports